import { render } from "./WdwSocialSharing.vue?vue&type=template&id=ef48b88a&scoped=true"
import script from "./WdwSocialSharing.vue?vue&type=script&lang=js"
export * from "./WdwSocialSharing.vue?vue&type=script&lang=js"

import "./WdwSocialSharing.vue?vue&type=style&index=0&id=ef48b88a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef48b88a"]])

export default __exports__